import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchStores = async () => {
  const res = await axios.get(`${API_URL}/stores`, header());
  return res.data;
};

export const fetchStore = async (id) => {
  const res = await axios.get(`${API_URL}/stores/${id}`, header());
  return res.data;
};

export const createStore = async (data) => {
  const res = await axios.post(`${API_URL}/stores`, data, header());
  return res.data;
};

export const updateStore = async (id, data) => {
  const res = await axios.put(`${API_URL}/stores/${id}`, data, header());
  return res.data;
};

export const deleteStore = async (id) => {
  await axios.delete(`${API_URL}/stores/${id}`, header());
};

export const addProcessorToStore = async (id, user_id) => {
  const res = await axios.patch(`${API_URL}/stores/${id}/processors/add`, { user_id }, header());
  return res.data;
};

export const removeProcessorFromStore = async (id, user_id) => {
  const res = await axios.patch(`${API_URL}/stores/${id}/processors/remove`, { user_id }, header());
  return res.data;
};

export default {
  fetchStores,
  fetchStore,
  createStore,
  updateStore,
  deleteStore,
  addProcessorToStore,
  removeProcessorFromStore,
};
